// extracted by mini-css-extract-plugin
export default {"readonly":"Table_readonly__+voMg"};